import React from 'react'
import { AreaEditorProps, DashboardAreaKeys } from '../../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import DashboardArea from '../DashboardArea'
import { DASHBOARD_EDITOR_STATISTICS_AREA_ID } from 'src/Libs/qa/ids'

/**
 * Statistics area for the dashboard editor
 */
const StatisticsArea: React.FC<AreaEditorProps> = ({ hidden, setHidden, position, getMenuItems, disabled }) => {
  const { t } = useCustomTranslation()

  return (
    <DashboardArea
      areaKey={DashboardAreaKeys.statistics}
      name={t('dashboard.editor.statistics')}
      hidden={hidden}
      setHidden={setHidden}
      position={position}
      getMenuItems={getMenuItems}
      disabled={disabled}
      dataQa={DASHBOARD_EDITOR_STATISTICS_AREA_ID}
    />
  )
}

export default StatisticsArea
